// extracted by mini-css-extract-plugin
module.exports = {"container":"container__IsCvZ3UyEGmw7","grey":"grey__VBze4i3XXWLbU","blue":"blue__2AiXocsD9YQ-V","red":"red__7C6jpwqPuHKa7","yellow":"yellow__EeUcziBcbZh5V"};